module.exports = __webpack_public_path__ + "img/z-1.1eb81f6e.png";